import { getScavengerState, setScavengerState, getBoulders } from './desertState.js';

export function updateScavengerState(deltaTime, width, height) {
  const scavengerState = getScavengerState();
  scavengerState.timer += deltaTime;
  
  // Random chance to spawn scavenger (very infrequent)
  if (!scavengerState.active && scavengerState.timer > 18) {
    const spawnChance = 0.0004;
    if (Math.random() < spawnChance) {
      const availableBoulders = getBoulders().filter(b => !b.mined);
      if (availableBoulders.length > 0) {
        setScavengerState({
          active: true,
          targetBoulder: availableBoulders[Math.floor(Math.random() * availableBoulders.length)],
          x: Math.random() * width,
          y: height * 0.7 + Math.random() * height * 0.2,
          miningTimer: 0,
          timer: 0
        });
      }
    }
  }
  
  // Update active scavenger
  if (scavengerState.active && scavengerState.targetBoulder) {
    const dx = scavengerState.targetBoulder.x - scavengerState.x;
    const dy = scavengerState.targetBoulder.y - scavengerState.y;
    const distance = Math.sqrt(dx * dx + dy * dy);
    
    if (distance > 35) {
      const speed = 45 * deltaTime;
      scavengerState.x += (dx / distance) * speed;
      scavengerState.y += (dy / distance) * speed;
    } else {
      scavengerState.miningTimer += deltaTime;
      if (scavengerState.miningTimer > 6) {
        scavengerState.targetBoulder.mined = true;
        setScavengerState({
          active: false,
          timer: 0
        });
        
        setTimeout(() => {
          scavengerState.targetBoulder.mined = false;
          scavengerState.targetBoulder.x = Math.random() * width;
          scavengerState.targetBoulder.y = height * 0.3 + Math.random() * height * 0.4;
        }, 25000);
      }
    }
  }
}

export function drawScavenger(ctx, time) {
  const scavengerState = getScavengerState();
  if (!scavengerState.active) return;
  
  ctx.save();
  
  const x = scavengerState.x;
  const y = scavengerState.y;
  const isMining = scavengerState.miningTimer > 0;
  
  // Scavenger shadow
  ctx.fillStyle = 'rgba(0, 0, 0, 0.35)';
  ctx.beginPath();
  ctx.ellipse(x, y + 18, 14, 5, 0, 0, Math.PI * 2);
  ctx.fill();
  
  // Hooded cloak body
  const cloakGradient = ctx.createLinearGradient(x, y - 22, x, y + 18);
  cloakGradient.addColorStop(0, 'hsl(28, 35%, 22%)');
  cloakGradient.addColorStop(0.5, 'hsl(24, 32%, 18%)');
  cloakGradient.addColorStop(1, 'hsl(20, 28%, 14%)');
  
  ctx.fillStyle = cloakGradient;
  ctx.beginPath();
  ctx.ellipse(x, y, 9, 17, 0, 0, Math.PI * 2);
  ctx.fill();
  
  // Hood
  ctx.fillStyle = 'hsl(24, 32%, 16%)';
  ctx.beginPath();
  ctx.arc(x, y - 12, 11, 0, Math.PI);
  ctx.fill();
  
  // Glowing eyes under hood
  ctx.fillStyle = 'hsl(195, 100%, 75%)';
  ctx.beginPath();
  ctx.arc(x - 3.5, y - 9, 1.2, 0, Math.PI * 2);
  ctx.arc(x + 3.5, y - 9, 1.2, 0, Math.PI * 2);
  ctx.fill();
  
  // Enhanced laser gun
  if (isMining) {
    // Gun body
    ctx.fillStyle = 'hsl(0, 0%, 25%)';
    ctx.fillRect(x + 9, y - 6, 18, 5);
    
    // Gun details
    ctx.fillStyle = 'hsl(0, 0%, 35%)';
    ctx.fillRect(x + 11, y - 5, 2, 3);
    ctx.fillRect(x + 15, y - 5, 2, 3);
    
    // Laser beam to target boulder
    if (scavengerState.targetBoulder) {
      const targetX = scavengerState.targetBoulder.x;
      const targetY = scavengerState.targetBoulder.y;
      
      // Enhanced laser beam
      const gradient = ctx.createLinearGradient(x + 27, y - 3.5, targetX, targetY);
      gradient.addColorStop(0, 'hsla(0, 100%, 75%, 0.95)');
      gradient.addColorStop(0.5, 'hsla(8, 100%, 65%, 0.8)');
      gradient.addColorStop(1, 'hsla(15, 100%, 55%, 0.7)');
      
      ctx.strokeStyle = gradient;
      ctx.lineWidth = 4;
      ctx.lineCap = 'round';
      ctx.beginPath();
      ctx.moveTo(x + 27, y - 3.5);
      ctx.lineTo(targetX, targetY);
      ctx.stroke();
      
      // Laser glow
      ctx.save();
      ctx.shadowColor = 'rgba(255, 0, 0, 0.9)';
      ctx.shadowBlur = 12;
      ctx.stroke();
      ctx.restore();
      
      // Enhanced impact sparks at boulder
      for (let i = 0; i < 8; i++) {
        const sparkAngle = Math.random() * Math.PI * 2;
        const sparkDist = Math.random() * 20;
        const sparkX = targetX + Math.cos(sparkAngle) * sparkDist;
        const sparkY = targetY + Math.sin(sparkAngle) * sparkDist;
        
        ctx.fillStyle = `hsla(${Math.random() * 60}, 100%, 75%, ${Math.random()})`;
        ctx.beginPath();
        ctx.arc(sparkX, sparkY, 1.5 + Math.random() * 2.5, 0, Math.PI * 2);
        ctx.fill();
      }
    }
  }
  
  ctx.restore();
}